const rawVersion = import.meta.env.VITE_APP_VERSION ?? __APP_VERSION__;
const formattedVersion = rawVersion.trim() || '0.0.0';
export const getAppVersion = () => formattedVersion;
export const APP_VERSION = formattedVersion;
export default getAppVersion;
